import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { browserHistory } from 'react-router'
import {
  Button,
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup
} from 'react-bootstrap'

import Collapsible from './collapsible'
import StatesDropdown from './statesdropdown'
//import Dropdown from './dropdown'
import Validators from '../utils/validators'
import Tasks from './partner/partnertasks'
import PartnerNotes from './partner/partnernotes'

@observer(['activities', 'partners', 'globals'])
export default class Partner extends Component {
  constructor(props) {
    super(props)

    let partnerId = this.props.params.partnerId
    let taskId = 0
    let noteId = 0

    if (this.props.params.type && this.props.params.type == 'task') {
      taskId = this.props.params.typeId
    }

    if (this.props.params.type && this.props.params.type == 'note') {
      noteId = this.props.params.typeId
    }

    //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
    //this.props.activities.logNewActivity(localStorage.getItem('userId'), 'read', 5, partnerId, 3, localStorage.getItem('userOrganizationId'))

    this.state = {
      showDetailsModal: true,
      partnerCode: 'Loading...',
      partnerFirstName: 'Loading...',
      partnerLastName: 'Loading...',
      partnerAddress: 'Loading...',
      partnerCity: 'Loading...',
      partnerState: 'Loading...',
      partnerZipCode: 'Loading...',
      partnerEmail: 'Loading...',
      partnerPhone: 'Loading...',
      partnerName: 'Loading...',
      noteId: noteId,
      taskId: taskId
    }

    this.props.partners.loadAllPartnerCompanies()
    this.props.partners.loadPartnerCompanies()
    this.loadPartnerDetails(partnerId)
    //this.forceUpdate()
  }

  
  componentWillReceiveProps(newProps) {
    if (newProps.params && newProps.params.partnerId) {
      this.setState({
        loadableState: true
      })
      this.loadPartnerDetails(newProps.params.partnerId)
    }
  }
  

  loadPartnerDetails(partnerId, callback) {
    this.props.partners.loadPartner(partnerId, (data) => {

      this.setState({
        partnerCode: data.partnerCode,
        partnerFirstName: data.firstName,
        partnerLastName: data.lastName,
        partnerAddress: data.address,
        partnerCity: data.city,
        partnerState: data.state,
        partnerZipCode: data.zipCode,
        partnerEmail: data.email,
        partnerPhone: data.phone,
        partnerName: data.firstName + ' ' + data.lastName,
        loadableState: false
      })

      if (callback) {
        callback()
      }
    })
  }

  back(e) {
    browserHistory.push('/partners')
  }

  open() {
    this.setState({
      showDetailsModal: true
    })
  }

  close() {
    this.setState({
      showDetailsModal: false
    })
  }

  validateEditPartnerForm() {
    if (this.getEditPartnerCodeValidationState() == 'error') {
      return false
    }

    if (this.getEditPartnerFirstNameValidationState() == 'error') {
      return false
    }

    if (this.getEditPartnerLastNameValidationState() == 'error') {
      return false
    }

    /*
    if (this.getEditPartnerAddressValidationState() == 'error') {
      return false
    }

    if (this.getEditPartnerCityValidationState() == 'error') {
      return false
    }

    if (this.getEditPartnerZipCodeValidationState() == 'error') {
      return false
    }
    */

    if (this.getEditPartnerEmailValidationState() == 'error') {
      return false
    }

    /*
    if (this.getEditPartnerPhoneValidationState() == 'error') {
      return false
    }
    */

    return true
  }

  getEditPartnerCodeValidationState() {
    if (this.state && Validators.validString(this.state.partnerCode)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditPartnerFirstNameValidationState() {
    if (this.state && Validators.validString(this.state.partnerFirstName)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditPartnerLastNameValidationState() {
    if (this.state && Validators.validString(this.state.partnerLastName)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditPartnerAddressValidationState() {
    if (this.state && Validators.validString(this.state.partnerAddress)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditPartnerCityValidationState() {
    if (this.state && Validators.validString(this.state.partnerCity)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditPartnerZipCodeValidationState() {
    if (this.state && Validators.validString(this.state.partnerZipCode)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditPartnerEmailValidationState() {
    if (this.state && Validators.validEmail(this.state.partnerEmail)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  getEditPartnerPhoneValidationState() {
    if (this.state && Validators.validString(this.state.partnerPhone)) {
      return 'success'
    } else {
      return 'error'
    }
  }

  editPartnerCodeChanged(e) {
    this.setState({
      partnerCode: e.target.value
    })
  }

  editPartnerFirstNameChanged(e) {
    this.setState({
      partnerFirstName: e.target.value
    })
  }

  editPartnerLastNameChanged(e) {
    this.setState({
      partnerLastName: e.target.value
    })
  }

  editPartnerAddressChanged(e) {
    this.setState({
      partnerAddress: e.target.value
    })
  }

  editPartnerCityChanged(e) {
    this.setState({
      partnerCity: e.target.value
    })
  }

  editPartnerZipCodeChanged(e) {
    this.setState({
      partnerZipCode: e.target.value
    })
  }

  editPartnerEmailChanged(e) {
    this.setState({
      partnerEmail: e.target.value
    })
  }

  editPartnerPhoneChanged(e) {
    this.setState({
      partnerPhone: e.target.value
    })
  }

  onStateChanged(e) {
    this.setState({
      partnerState: e.target.value
    })
  }

  updatePartner(e) {
    const pct = document.getElementById('partnerCompany_Type').value.split(',')
    const data = {
      id: this.props.params.partnerId,
      organizationId: this.props.globals.loggedInUser.organizationId,
      partnerCompanyId: pct[0],
      partnerTypeId: pct[1],
      partnerCode: this.state.partnerCode,
      firstName: this.state.partnerFirstName,
      lastName: this.state.partnerLastName,
      address: this.state.partnerAddress,
      city: this.state.partnerCity,
      state: this.state.partnerState,
      zipCode: this.state.partnerZipCode,
      email: this.state.partnerEmail,
      phone: this.state.partnerPhone
    }

    if (this.validateEditPartnerForm()) {
      this.props.partners.updatePartner(data, () => { alert('Partner Updated') })
      //Log activity //Log activity logNewActivity(userId, activity, activitySectionTypeId, activitySectionId, entityTypeId, entityId)
      this.props.activities.logNewActivity(localStorage.getItem('userId'), 'update', 5, this.props.params.partnerId, 3, localStorage.getItem('userOrganizationId'))
      this.setState({
        partnerName: data.firstName + ' ' + data.lastName,
        showDetailsModal: false
      })
    } else {
      alert('Please check the form.  Required data is missing.')
    }


  }

  render() {

    const partnerTypeDropdown = this.props.partners.all ?
    (
      <FormControl componentClass="select" id="partnerCompany_Type">
        {
          this.props.partners.all.map((comp) => {
            return (
              <optgroup label={ comp.name }>
              {
                comp.partnerTypes ? comp.partnerTypes.map((pt) => {
                  return (<option value={ comp.id + ',' + pt.id }>{ pt.name }</option>)
                }) : (<option>LOADING...</option>)
              }
              </optgroup>
            )
          })
        }
      </FormControl>
    ) : (
      <div>Loading...</div>
    )

    var detailsTable = (
      <div>
        <div>
          <Form horizontal name="partnerDetails">
          <FormGroup>
            <Col componentClass={ ControlLabel } sm={ 2 }>Type:</Col>
            <Col sm={ 6 }>{ partnerTypeDropdown }</Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ ControlLabel } sm={ 2 }>Code:</Col>
            <Col sm={ 6 }>
              <FormGroup validationState={ this.getEditPartnerCodeValidationState() }>
                <FormControl placeholder="Partner Code" id="partnerCode" value={ this.state.partnerCode } onChange={ this.editPartnerCodeChanged.bind(this) } />
              </FormGroup>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ ControlLabel } sm={ 2 }>First Name:</Col>
            <Col sm={ 6 }>
              <FormGroup validationState={ this.getEditPartnerFirstNameValidationState() }>
                <FormControl placeholder="First Name" id="partnerFirstName" value={ this.state.partnerFirstName } onChange={ this.editPartnerFirstNameChanged.bind(this) } />
              </FormGroup>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ ControlLabel } sm={ 2 }>Last Name:</Col>
            <Col sm={ 6 }>
              <FormGroup validationState={ this.getEditPartnerLastNameValidationState() }>
                <FormControl placeholder="Last Name" id="partnerLastName" value={ this.state.partnerLastName } onChange={ this.editPartnerLastNameChanged.bind(this) } />
              </FormGroup>
            </Col>
          </FormGroup>
          { /*
          <FormGroup>
            <Col componentClass={ ControlLabel } sm={ 2 }>Address:</Col>
            <Col sm={ 8 }>
              <FormGroup validationState={ this.getEditPartnerAddressValidationState() }>
                <FormControl placeholder="Address" id="partnerAddress" onChange={ this.editPartnerAddressChanged.bind(this) } />
              </FormGroup>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ ControlLabel } sm={ 2 }>City:</Col>
            <Col sm={ 4 }>
              <FormGroup validationState={ this.getEditPartnerCityValidationState() }>
                <FormControl placeholder="City" id="partnerCity" onChange={ this.editPartnerCityChanged.bind(this) } />
              </FormGroup>
            </Col>
          </FormGroup>
          */ }
          <FormGroup>
            <Col componentClass={ ControlLabel } sm={ 2 }>Address:</Col>
            <Col sm={ 8 }><FormControl placeholder="Address" id="partnerAddress" value={ this.state.partnerAddress } onChange={ this.editPartnerAddressChanged.bind(this) } /></Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ ControlLabel } sm={ 2 }>City:</Col>
            <Col sm={ 4 }><FormControl placeholder="City" id="partnerCity" value={ this.state.partnerCity } onChange={ this.editPartnerCityChanged.bind(this) } /></Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ ControlLabel } sm={ 2 }>State:</Col>
            <Col sm={ 4 }><StatesDropdown id="partnerState" defaultValue={ this.state.partnerState } onChange={ this.onStateChanged.bind(this) } /></Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ ControlLabel } sm={ 2 }>Zip Code:</Col>
            <Col sm={ 4 }>
              { /* <FormGroup validationState={ this.getEditPartnerZipCodeValidationState() }> */ }
              <FormGroup>
                <FormControl placeholder="Zip Code" id="partnerZipCode" value={ this.state.partnerZipCode } onChange={ this.editPartnerZipCodeChanged.bind(this) } />
              </FormGroup>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ ControlLabel } sm={ 2 }>Email:</Col>
            <Col sm={ 6 }>
              <FormGroup validationState={ this.getEditPartnerEmailValidationState() }>
                <FormControl placeholder="Email" id="partnerEmail" value={ this.state.partnerEmail } onChange={ this.editPartnerEmailChanged.bind(this) } />
              </FormGroup>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ ControlLabel } sm={ 2 }>Phone:</Col>
            <Col sm={ 6 }>
              { /* <FormGroup validationState={ this.getEditPartnerPhoneValidationState() }> */ }
              <FormGroup>
                <FormControl placeholder="Phone" id="partnerPhone" value={ this.state.partnerPhone } onChange={ this.editPartnerPhoneChanged.bind(this) } />
              </FormGroup>
            </Col>
          </FormGroup>
            <FormGroup>
              <Col sm={ 2 }></Col>
              <Col sm={ 8 }>
                <Button bsStyle="success" onClick={ this.updatePartner.bind(this) }><i className="fa fa-floppy-o" aria-hidden="true"></i> Save</Button>
                <Button bsStyle="danger" onClick={ this.close.bind(this) }><i className="fa fa-ban" aria-hidden="true"></i> Cancel</Button>
              </Col>
            </FormGroup>
          </Form>
        </div>
      </div>
    )

    var notesPanel = (
      <div>
        <PartnerNotes partnerId={ this.props.params.partnerId } noteId={ this.state.noteId } />
      </div>
    )

    var tasksPanel = (
      <div>
        <Tasks partnerId={ this.props.params.partnerId } taskId={ this.state.taskId } />
      </div>
    )

    return (
      <div className="right_col" role="main" style={{ height: 'inherit' }}>
        <div className="">
          <div className="page-title">
            { /*
            <div className="title_left">
            <Breadcrumb>
              <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
              <Breadcrumb.Item href="/partners">Partners</Breadcrumb.Item>
              <Breadcrumb.Item active>{ this.state.partnerName }</Breadcrumb.Item>
            </Breadcrumb>
            </div>
            */ }
          </div>
          <div className="clearfix"></div>
          <Collapsible title="Details" content={ detailsTable } />
        </div>
        <div className="clearfix"></div>
        <Collapsible title="Notes" content={ notesPanel } />
        <div className="clearfix"></div>
        <Collapsible title="Tasks" content={ tasksPanel } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partner.js